"use client";

import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useMemo, useState } from "react";
import { useRouter } from "next/navigation";
import { useSelector } from "react-redux";

import styles from "./certificate-eligibility.module.scss";
import Button from "@/components/atoms/buttons/Button";
import Components from "@/components";

const STEPS_TO_REQUEST_CERTIFICATE = [
  { id: 1, icon: "ix:user-settings-filled", text: "Check Eligibility" },
  { id: 2, icon: "clarity:form-line", text: "Submit Feedback" },
  { id: 3, icon: "fluent:certificate-16-filled", text: "Request Certificate" },
  { id: 4, icon: "dashicons:email-alt", text: "Get Certificate on Email" },
];

const CertificateEligibility = ({
  loading,
  eligibility,
  setShowCtfModal,
  handleNextClick,
}) => {
  const { courseInfo, isEnrolled } = useSelector((state) => state.video);
  const [step, setStep] = useState("steps");
  const router = useRouter();

  const getRoute = useMemo(() => {
    if (!eligibility) return "";
    if (!eligibility?.feedbackShared) {
      return `/certificate/feedback?id=${courseInfo?._id}&docheck=false`;
    }
    return `/certificate/request?id=${courseInfo?._id}`;
  }, [courseInfo, eligibility]);

  const renderStepsUI = () => (
    <>
      <h2 className={styles.title}>Steps to request certificate</h2>
      <article>
        {STEPS_TO_REQUEST_CERTIFICATE.map((step) => (
          <React.Fragment key={step.id}>
            <div>
              <Icon icon={step.icon} />
              <p>{step.text}</p>
            </div>
            {step.id < 4 && <Icon icon="gravity-ui:arrow-right" />}
          </React.Fragment>
        ))}
      </article>

      <Button
        name={loading ? "Check eligibility" : "Next"}
        disabled={loading}
        handleClick={() => handleNextClick()}
      />
    </>
  );

  const renderIneligibleMessage = () => (
    <>
      <h2 className={styles.title}>You're not eligible for the certificate!</h2>

      <div className={styles.progressWrapper}>
        <Components.CircularProgressBar progress={isEnrolled?.progress} />
      </div>

      <p className={styles.para}>
        Watch all video with green ticks to become eligible for the certificate.
      </p>
      <Button
        name="Let's complete"
        handleClick={() => setShowCtfModal(false)}
      />
    </>
  );

  const renderEligibleMessage = () => (
    <>
      <h2 className={styles.title}>
        You&apos;re eligible to request your certificate 🎓
      </h2>

      <div className={styles.progressWrapper}>
        <Components.CircularProgressBar progress={isEnrolled?.progress} />
      </div>

      <p className={styles.para}>To complete the process, Go to next step.</p>

      <Button
        name={eligibility?.feedbackShared ? "Next" : "Go to Feedback"}
        handleClick={() => router.push(getRoute)}
      />
    </>
  );

  useEffect(() => {
    if (eligibility !== null) {
      if (eligibility.hasSeenAllVideos) setStep("eligible");
      else setStep("ineligible");
    }
  }, [eligibility]);

  return (
    <section className={styles.container}>
      {step === "steps" && renderStepsUI()}
      {step === "ineligible" && renderIneligibleMessage()}
      {step === "eligible" && renderEligibleMessage()}
    </section>
  );
};

export default CertificateEligibility;
